// extracted by mini-css-extract-plugin
export default {"techSpec":"ProductTechSpecs_techSpec__Q8x29","specName":"ProductTechSpecs_specName__VGMES","specDescription":"ProductTechSpecs_specDescription__xeOZ8"};